const IMAGE_TIMEOUT_MS = 15000;

function loadImageAttempt(url) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        let settled = false;
        let timer;
        const finish = (error, result) => {
            if (settled) {
                return;
            }
            settled = true;
            clearTimeout(timer);
            image.onload = null;
            image.onerror = null;
            if (error) {
                error.imageUrl = url;
                image.src = '';
                reject(error);
            } else {
                resolve(result);
            }
        };
        image.setAttribute('crossOrigin', 'anonymous');
        image.onload = () => {
            try {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = image.width;
                canvas.height = image.height;
                ctx.drawImage(image, 0, 0);
                // Reuse the decoded canvas instead of decoding a base64 copy again.
                finish(null, {
                    width: image.width,
                    height: image.height,
                    texture: new THREE.CanvasTexture(canvas)
                });
            } catch (error) {
                finish(error);
            }
        };
        image.onerror = () => finish(new Error('素材图片加载失败'));
        timer = setTimeout(() => finish(new Error('素材图片加载超时')), IMAGE_TIMEOUT_MS);
        image.src = url;
    });
}

async function loadImageToTexture(url) {
    try {
        return await loadImageAttempt(url);
    } catch (error) {
        // Retry once with a fresh Image after releasing the failed request.
        return loadImageAttempt(url);
    }
}
export default loadImageToTexture;
